import { Map } from 'immutable';
import { NERD_TRAINING } from '@constants/actions';

/**
 * @todo
 * 2. typescript types update
 */
export type NerdTrainingState = {
  inited: boolean;
  loading: boolean;
  error: string;
  entityResult: {
    searchedString: string;
    entityList: Entity[]
  } | null;
  articleContent: Article | null;
  submitMessage: SubmitMessage | null;
};

export type NerdTrainingActions = Loading
| Error
| UpdateEntityList
| InitArticleContent
| SetSubmitMessage;

export type NerdTrainingActionTypes = {
  [Key in keyof typeof NERD_TRAINING]: typeof NERD_TRAINING[Key]
};

export interface SetSubmitMessage {
  type: NerdTrainingActionTypes['SET_SUBMIT_MESSAGE'];
  payload: {
    isSuccess: boolean;
    message: string;
  };
}
export interface Loading {
  type: NerdTrainingActionTypes['LOADING'];
}

export interface Error {
  type: NerdTrainingActionTypes['ERROR'];
  payload: string;
}

export interface UpdateEntityList {
  type: NerdTrainingActionTypes['UPDATE_ENTITY_RESULT'];
  payload: Entity[];
}

export interface InitArticleContent {
  type: NerdTrainingActionTypes['INIT_ARTICLE_CONTENT'];
  payload: Article;
}

export type Entity = any;

export type Article = any;

export type SubmitMessage = {
  isSuccess: boolean;
  message: string;
};

const initialState = Map({
  inited: false,
  loading: false,
  error: '',
  entityResult: null,
  articleContent: null,
  submitMessage: null,
  submitting: false,
});

const NerdTraining = (state = initialState, action: any) => {
  switch (action.type) {
    case NERD_TRAINING.LOADING:
      return state.set('loading', true).set('inited', false).set('error', '');

    case NERD_TRAINING.ERROR:
      return state.set('error', action.payload).set('loading', false).set('articleContent', null);

    case NERD_TRAINING.SET_SUBMIT_MESSAGE:
      return state.set('submitMessage', action.payload);

    case NERD_TRAINING.UPDATE_ENTITY_RESULT:
      return state.set('entityResult', action.payload);
    
    case NERD_TRAINING.INIT_ARTICLE_CONTENT:
      return state
        .set('articleContent', action.payload)
        .set('loading', false)
        .set('inited', true)
        .set('error', '')
        .set('submitMessage', null);
    case NERD_TRAINING.SET_SUBMITTING:
      return state
        .set('submitting', action.payload);
    default:
      return state;
  }
};

export default NerdTraining;
